import {
	type AITextMessage,
	MessageRole,
	MessageType,
} from '../types/messageTypes'

export const createAITextMessage = ({
	textMessage,
	isTimeoutAgentMessage,
}: {
	textMessage: string
	isTimeoutAgentMessage?: boolean
}): AITextMessage => ({
	isTimeoutAgentMessage,
	value: textMessage,
	type: MessageType.AIText,
	role: MessageRole.Ai,
	showAvatar: true,
})
